import dataFetcher from "../dataFetcher";

export const editPilotoService = async (data) => {
  try {
    const res = await dataFetcher.post("/piloto/editarpiloto", data);
    return {
      data: res.data,
      success: true,
    };
  } catch (error) {
    return {
      error: error.response.data,
      success: false,
    };
  }
};
